var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 167,
    viewBox: "0 0 226 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ApplePay_svg__filter0_d_353_4498)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.323,
    y: 21.323,
    width: 182.562,
    height: 124.354,
    rx: 14.552,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 2.646
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.165 67.27c2.488.21 4.975-1.259 6.53-3.12 1.528-1.915 2.539-4.486 2.28-7.108-2.203.105-4.923 1.468-6.478 3.383-1.425 1.652-2.642 4.328-2.332 6.845zm29.589 33.781V60.163h15.157c7.824 0 13.291 5.455 13.291 13.428 0 7.973-5.57 13.481-13.498 13.481h-8.68v13.979h-6.27zM72.948 67.769c-2.19-.128-4.19.667-5.805 1.309-1.04.413-1.92.763-2.59.763-.75 0-1.667-.369-2.696-.783-1.348-.542-2.89-1.162-4.506-1.132-3.705.052-7.151 2.177-9.042 5.56-3.887 6.767-1.01 16.785 2.746 22.293 1.84 2.728 4.042 5.718 6.944 5.613 1.276-.049 2.195-.444 3.145-.852 1.094-.47 2.23-.958 4.006-.958 1.713 0 2.8.476 3.843.932.992.434 1.945.851 3.36.825 3.005-.052 4.896-2.727 6.736-5.455 1.985-2.927 2.858-5.785 2.99-6.218l.015-.05a.705.705 0 00-.07-.035c-.664-.307-5.737-2.658-5.785-8.961-.049-5.29 4.023-7.971 4.664-8.393l.077-.052c-2.59-3.882-6.633-4.301-8.032-4.406zm60.707 33.596c3.938 0 7.591-2.02 9.249-5.219h.13v4.905h5.803V80.698c0-5.9-4.663-9.704-11.84-9.704-6.659 0-11.582 3.856-11.763 9.154h5.648c.467-2.518 2.773-4.17 5.934-4.17 3.834 0 5.985 1.81 5.985 5.14v2.256l-7.825.472c-7.281.445-11.219 3.462-11.219 8.707 0 5.298 4.068 8.812 9.898 8.812zm1.683-4.851c-3.342 0-5.467-1.626-5.467-4.118 0-2.57 2.047-4.065 5.959-4.301l6.97-.446v2.308c0 3.83-3.213 6.557-7.462 6.557zm32.75 6.136c-2.513 7.16-5.389 9.521-11.504 9.521-.466 0-2.021-.053-2.384-.157v-4.905a19.24 19.24 0 001.84.105c2.772 0 4.327-1.18 5.285-4.249l.57-1.809-10.622-29.768h6.555l7.384 24.155h.129l7.385-24.155h6.373l-11.011 31.262zm-68.065-37.137h7.229c5.441 0 8.55 2.937 8.55 8.104s-3.109 8.13-8.576 8.13h-7.203V65.513z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ApplePay_svg__filter0_d_353_4498",
    x: 0,
    y: 0,
    width: 225.208,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_353_4498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_353_4498",
    result: "shape"
  })))));
}
export default SvgApplePay;